import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">


                                            <div className="circle_title-first">
<span className="heading">
<img className="heading_image" src={require('@images/browndot.jpg')}/>
</span>
                                                <span className="heading">THE DEVELOPMENT MODEL</span>
                                            </div>
                                            <p>Eleven key steps have been identified for developing others.
                                                These are described in the following
                                                DEVELOPMENT model:</p>

                                            <div className="verticalword "><span
                                                className="greennumberroundbg CircleAbbr  ">D</span></div>
                                            <span
                                                className="circledesrption2 circlediscp verticalContentPadding">
    <p><span className="subtiltereg ">Data collection</span></p></span>
                                            <br/>
                                            <div className="verticalword"><span
                                                className="greennumberroundbg CircleAbbr">E</span></div>
                                            <span
                                                className="circledesrption2 circlediscp verticalContentPadding">
    <p><span className="subtiltereg ">Exchange of views</span></p></span>
                                            <br/>
                                            <div className="verticalword"><span
                                                className="greennumberroundbg CircleAbbr">V</span></div>
                                            <span
                                                className="circledesrption2 circlediscp verticalContentPadding">
    <p><span className="subtiltereg ">Vision of the future</span></p></span>
                                            <br/>
                                            <div className="verticalword"><span
                                                className="greennumberroundbg CircleAbbr">E</span>
                                            </div>
                                            <span
                                                className="circledesrption2 circlediscp verticalContentPadding">
    <p><span className="subtiltereg ">Environmental awareness</span></p></span>
                                            <br/>
                                            <div className="verticalword"><span
                                                className="greennumberroundbg CircleAbbr">L</span>
                                            </div>
                                            <span
                                                className="circledesrption2 circlediscp verticalContentPadding">
    <p><span className="subtiltereg ">Learning styles consideration</span></p></span>
                                            <br/>
                                            <div className="verticalword"><span
                                                className="greennumberroundbg CircleAbbr">O</span>
                                            </div>
                                            <span
                                                className="circledesrption2 circlediscp verticalContentPadding">
    <p><span className="subtiltereg ">Options for development</span></p></span>
                                            <br/>
                                            <div className="verticalword"><span
                                                className="greennumberroundbg CircleAbbr">P</span>
                                            </div>
                                            <span
                                                className="circledesrption2 circlediscp verticalContentPadding">
    <p><span className="subtiltereg ">Planning action</span></p></span>
                                            <br/>
                                            <div className="verticalword"><span
                                                className="greennumberroundbg CircleAbbr">M</span>
                                            </div>
                                            <span
                                                className="circledesrption2 circlediscp verticalContentPadding">
    <p><span className="subtiltereg ">Maintaining momentum</span></p></span>
                                            <br/>
                                            <div className="verticalword"><span
                                                className="greennumberroundbg CircleAbbr">E</span>
                                            </div>
                                            <span
                                                className="circledesrption2 circlediscp verticalContentPadding">
    <p><span className="subtiltereg ">Evaluating progress</span></p></span>
                                            <br/>
                                            <div className="verticalword">
                                                                                            <span
                                                                                                className="greennumberroundbg CircleAbbr">N</span>
                                            </div>
                                            <span
                                                className="circledesrption2 circlediscp verticalContentPadding">
    <p><span className="subtiltereg ">New directions</span></p></span>
                                            <br/>
                                            <div
                                                className="verticalword">
                                                                                                <span
                                                                                                    className="greennumberroundbg CircleAbbr">T</span>
                                            </div>
                                            <span
                                                className="circledesrption2 circlediscp verticalContentPadding">
    <p><span className="subtiltereg ">Taking stock</span></p></span>
                                            <br/>
                                            <div
                                                className="circle_title">
                                                <img
                                                    src={require('@images/browndot.jpg')}
                                                    alt=""/>THE
                                                DEVELOPMENT
                                                MODEL – STEP BY
                                                STEP
                                            </div>
                                            <div
                                                className="border_subtitle">Data
                                                collection
                                            </div>
                                            <p>This is the first
                                                thing to do. You
                                                need to start by
                                                gathering
                                                information about
                                                the role and the
                                                person involved.
                                                That means
                                                identifying gaps
                                                between actual and
                                                required
                                                performance, as well
                                                as assessing future
                                                requirements of both
                                                person and role.
                                                This information
                                                will provide the
                                                basis
                                                for a discussion
                                                between the two of
                                                you, and agreement
                                                about how to
                                                proceed.</p>
                                            <div
                                                className="border_subtitle">Exchange
                                                of views
                                            </div>
                                            <p>The point of this is
                                                to decide where
                                                development is
                                                needed and the
                                                result should be a
                                                mutually
                                                agreed list. The
                                                process should
                                                involve both sharing
                                                your views gained
                                                from data collection
                                                and
                                                exploring the views
                                                of the individual in
                                                relation to their
                                                development.</p>
                                            <div
                                                className="border_subtitle">Vision
                                                of the future
                                            </div>
                                            <p>This would be
                                                explored in the
                                                ‘exchange of views’
                                                discussion, but
                                                we’ve separated it
                                                to highlight
                                                the important
                                                difference between
                                                identifying an
                                                individual’s current
                                                proficiency or
                                                otherwise, and
                                                describing how this
                                                might evolve (and
                                                what the individual
                                                would like to
                                                achieve) in
                                                future.</p>


                                            <div
                                                className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page2')}
                                                     className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div
                                                className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page4')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}